import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Card, CardContent, Grid, Typography } from '../../../../components/mui/Core/index'
import { sessionStorageKeyConstants } from '../../../../constants/session-storage-key-constants'

function OrderItemDetailsCard() {
  const theme = useTheme()
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const dmsUser = selectedClient?.dmsFlag || authenticatedUser?.dms
  const selectedOrderItem = useSelector((state) => state.serialNumbers.selectedOrderItem)
  const selectedOrder = useSelector((state) => state.order.selectedOrder)
  const selectedShipment = useSelector((state) => state.orderList.selectedShipment)
  const expirationDate = selectedOrderItem?.expirationDate

  const cardStyle = {
    height: '80%',
    borderRadius: '12px',
    border: `solid 1px ${theme.palette.common.white}`,
    backgroundColor: theme.palette.common.white,
    mb: '10px',
  }

  const dateStyle = {
    textAlign: 'right',
    mr: '10px',
  }

  const quantityStyle = {
    textAlign: 'right',
    mr: '32px',
  }

  return (
    <Card variant='outlined' sx={cardStyle}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid size={{ xs: 1.2 }}>
            <Typography variant='h6'>Order</Typography>
          </Grid>
          {dmsUser === 'Y' && (
            <Grid size={{ xs: 1.3 }}>
              <Typography variant='h6'>Shipment</Typography>
            </Grid>
          )}
          <Grid size={{ xs: dmsUser === 'Y' ? 3.3 : 4 }}>
            <Typography variant='h6'>Item Description</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='h6'>Lot</Typography>
          </Grid>
          <Grid size={{ xs: 1.5 }} sx={dateStyle}>
            <Typography variant='h6'>Expiration Date</Typography>
          </Grid>
          <Grid size={{ xs: 1.4 }} sx={quantityStyle}>
            <Typography variant='h6'>Qty Ship/Ord</Typography>
          </Grid>
          <Grid size={{ xs: dmsUser === 'Y' ? 1.2 : 1.5 }}>
            <Typography variant='h6'>UOM</Typography>
          </Grid>
          <Grid>
            <Typography variant='h6'>Item Code</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {/* When
            DMS = Y, then dms order number
            DMS = N, then wms order number
          */}
          <Grid size={{ xs: 1.2 }}>
            {dmsUser === 'Y' && (
              <Typography variant='body1'>
                {selectedOrder?.dms_order ||
                  selectedOrder?.dmsOrderNum ||
                  selectedShipment?.dmsOrderNum ||
                  selectedShipment?.dms_order}
              </Typography>
            )}
            {dmsUser === 'N' && (
              <Typography variant='body1'>
                {selectedOrder?.wms_order ||
                  selectedOrder?.wmsOrderNum ||
                  selectedShipment?.wmsOrderNum}
              </Typography>
            )}
          </Grid>
          {/* When DMS = Y, display associated shipment number */}
          {dmsUser === 'Y' && (
            <Grid size={{ xs: 1.3 }}>
              <Typography variant='body1'>{selectedShipment?.wmsOrderNum}</Typography>
            </Grid>
          )}
          <Grid size={{ xs: dmsUser === 'Y' ? 3.3 : 4 }}>
            <Typography variant='body1'>{selectedOrderItem?.itemDescription}</Typography>
          </Grid>
          <Grid size={{ xs: 1 }}>
            <Typography variant='body1'>{selectedOrderItem?.lotNumber}</Typography>
          </Grid>
          <Grid size={{ xs: 1.5 }} sx={dateStyle}>
            <Typography variant='body1'>
              {(expirationDate && moment.utc(expirationDate).format('L')) || 'None'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 1.4 }} sx={quantityStyle}>
            <Typography variant='body1'>{`${selectedOrderItem?.shippedQty}/${selectedOrderItem?.orderQty}`}</Typography>
          </Grid>
          <Grid size={{ xs: dmsUser === 'Y' ? 1.2 : 1.5 }}>
            <Typography variant='body1'>{selectedOrderItem?.orderUOM}</Typography>
          </Grid>
          <Grid>
            <Typography variant='body1'>{selectedOrderItem?.itemHoldCode || 'None'}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default OrderItemDetailsCard
